<template>
  <div class="accordion-wrapper-wise">
    <div
      class="accordion-wise"
      v-for="(item, index) in userMessages"
      :key="index"
    >
      <div
        class="accordion-header-wise"
        @click="toggle(index)"
        :class="{ active: openIndex === index }"
      >
        <h4>{{ item.title }}</h4>
      </div>
      <transition name="fade">
        <div v-if="openIndex === index" class="accordion-content-wise">
          <div class="accordion-span-wise">
            <span>
              {{ item.status || '' }}
            </span>

            <span>
              {{ item.category }}
            </span>
          </div>
          <div
            class="accordion-content-message-wise"
            v-for="(message, idx) in item.message"
            :key="idx"
          >
            <h5>{{ message.text }}</h5>
          </div>
          <div class="button-group">
            <button class="btn btn-info" @click="editMessage(item)">
              Editar
            </button>
            <button class="btn btn-danger" @click="showConfirmModal = true">
              Excluir
            </button>
            <ConfirmModal
              v-if="showConfirmModal"
              :isVisibleConfirm="showConfirmModal"
              @close="showConfirmModal = false"
              :message="'Deseja realmente deletar a mensagem?'"
              :onConfirm="() => deleteMessage(item)"
            />
            <Loading
              v-if="showLoadingModalWise"
              :isLoading="isLoadingModalWise"
              @close="showLoadingModalWise = false"
            />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { deleteMessageWise } from '../../../../../../../api/wise';
import ConfirmModal from '../../../../components/ConfirmModal.vue';
import Loading from '../../../../components/Loading.vue';
export default {
  components: { ConfirmModal, Loading },
  data() {
    return {
      openIndex: null,
      textMessage: [],
      showConfirmModal: false,
      showLoadingModalWise: false,
      isLoadingModalWise: false,
      message: [],
    };
  },
  props: {
    userMessages: {
      type: Array,
      required: true,
    },
    selectMessageToEdit: {
      type: Object,
      required: false,
    },
  },
  methods: {
    ...mapActions(['loadMessageWise']),
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    editMessage(data) {
      this.$emit('selectMessageToEdit', { message: data });
      this.$emit('isEditMessage');
    },
    async deleteMessage(data) {
      this.message = data;
      this.showLoadingModalWise = true;
      this.isLoadingModalWise = true;
      await deleteMessageWise({ message: data });
      await this.loadMessageWise();
      this.isLoadingModalWise = false;
      this.showLoadingModalWise = false;
    },
  },

  watch: {
    userMessages: {
      handler(newVal) {
        this.textMessage = newVal.map(msg => msg.message.filter(m => m.text));
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.accordion-wrapper-wise {
  padding: 20px;
  background: white;
}

.accordion-wise {
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 5px;
}

.accordion-header-wise {
  padding: 10px;
  cursor: pointer;
  transition: background 0.3s;
}
.accordion-header-wise h4 {
  font-size: 18px;
}

.accordion-header-wise:hover {
  background: #ddd;
}

.accordion-header-wise.active {
  background: #01c6d8;
  color: white;
}
.accordion-header-wise.active h4 {
  color: white;
}
.accordion-span-wise {
  display: flex;
  gap: 15px;
  padding: 0 0 15px 0;
}
.accordion-span-wise span {
  border: 2px solid #01c6d8;
  border-radius: 4px;
  color: #01c6d8;
  padding: 5px;
  font-size: 14px;
}

.accordion-content-wise {
  padding: 2%;
  background: white;
}
.accordion-content-message-wise {
  padding: 20px;
  background: white;
  border-top: 1px solid #ccc;
}

.accordion-content-message-wise h5 {
  font-weight: 400;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.button-group {
  gap: 10px;
}
</style>
